import React from 'react';
import { ILegalClient } from '../../Interfaces/ILegalClient';
import { Box, Card, CardContent, IconButton, Typography } from '@mui/material';
import { Cell, Legend, Pie, PieChart, ResponsiveContainer } from 'recharts';
import { Close } from '@mui/icons-material';

export interface IChartData {
  name: string;
  value: number;
}

interface IProps {
  legalClientArray: ILegalClient[];
  keyName: string;
  activeDashboard: string[];
  setActiveDashboard: Function;
}

export const PieChartUser: React.FC<IProps> = ({
  legalClientArray,
  keyName,
  activeDashboard,
  setActiveDashboard,
}) => {
  const chartData = (): IChartData[] => {
    return [
      {
        name: 'Aktiv',
        value: legalClientArray.filter(
          x => x.last_login_at !== null && Boolean(x.loginPossible) === true
        ).length,
      },
      {
        name: 'Gesperrt',
        value: legalClientArray.filter(
          x => x.last_login_at !== null && Boolean(x.loginPossible) === false
        ).length,
      },
      {
        name: 'Inaktive',
        value: legalClientArray.filter(x => x.last_login_at === null).length,
      },
    ];
  };

  const COLORS = [
    'rgb(46, 125, 50)', // Angemeldete
    'rgb(237, 108, 2)', // Vorabsprache
    'rgb(211, 47, 47)', // Nicht angemeldete
  ];

  const RADIAN = Math.PI / 180;
  const renderCustomizedLabel = (props: any) => {
    const radius =
      Number(props['innerRadius']) +
      (Number(props['outerRadius']) - Number(props['innerRadius'])) * 0.5;
    const x =
      Number(props['cx']) +
      radius * Math.cos(-Number(props['midAngle']) * RADIAN);
    const y =
      Number(props['cy']) +
      radius * Math.sin(-Number(props['midAngle']) * RADIAN);

    return (
      <text
        x={x}
        y={y}
        fill='white'
        textAnchor={x > Number(props['cx']) ? 'start' : 'end'}
        dominantBaseline='central'
      >
        {`${(Number(props['percent']) * 100).toFixed(0)}%`}
      </text>
    );
  };

  const onRemove = () => {
    setActiveDashboard([...activeDashboard.filter(x => x !== keyName)]);
  };

  return (
    <Card variant='outlined'>
      <IconButton sx={{ float: 'right' }} onClick={onRemove}>
        <Close sx={{ fontSize: 14 }} />
      </IconButton>
      <CardContent>
        <Box sx={{ display: 'flex' }}>
          <Typography mb={3}>Kontenverteilung</Typography>
        </Box>
        <Box
          sx={{
            height: { xs: 150, sm: 250, xl: 300 },
            minWidth: 300,
            mt: 2,
            width: '100%',
          }}
        >
          <ResponsiveContainer width='100%' height='100%'>
            <PieChart>
              <Pie
                data={chartData()}
                cx='50%'
                cy='45%' // etwas höher setzen, um Platz für Legende unten zu schaffen
                labelLine={false}
                outerRadius='80%'
                fill='#4cb1ad'
                dataKey='value'
                label={renderCustomizedLabel}
              >
                {chartData().map((entry, index) => (
                  <Cell
                    key={`cell-${index}`}
                    fill={COLORS[index % COLORS.length]}
                  />
                ))}
              </Pie>
              <Legend
                layout='horizontal'
                verticalAlign='bottom'
                align='center'
              />
            </PieChart>
          </ResponsiveContainer>
        </Box>
      </CardContent>
    </Card>
  );
};
